import type { ApolloError } from '@apollo/client';
import { useAppDispatch } from 'redux/hooks';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { apolloErrorAdded } from '../redux/alerts-slice';

/** Accepts an array of possible Apollo errors and renders them as alerts */
const useApolloErrorAlerts = (errors: (ApolloError | undefined)[]) => {
	const dispatch = useAppDispatch();

	useDeepCompareEffect(() => {
		for (const error of errors) {
			if (error) dispatch(apolloErrorAdded(error));
		}
	}, [dispatch, errors]);
};

export default useApolloErrorAlerts;
